import { computed, useAttrs } from "vue";
import type { StyleValue } from "vue";

export function useAttrsAndStyle() {
  const $attrs = useAttrs();

  const functionalAttrs = computed(() => {
    const attrs = { ...$attrs };
    if ("style" in attrs) delete attrs.style;
    if ("class" in attrs) delete attrs.class;
    return attrs;
  });

  const styleAttrs = computed(() => {
    const style: StyleValue = ($attrs.style as StyleValue | undefined) ?? {};
    const classValues = $attrs.class ?? "";
    return { style, class: classValues };
  });

  return {
    functionalAttrs,
    styleAttrs
  };
}
